import { render, staticRenderFns } from "./potentialSupplierManageDetail.vue?vue&type=template&id=314c0ea2&scoped=true"
import script from "./potentialSupplierManageDetail.vue?vue&type=script&lang=js"
export * from "./potentialSupplierManageDetail.vue?vue&type=script&lang=js"
import style0 from "./potentialSupplierManageDetail.vue?vue&type=style&index=0&id=314c0ea2&lang=scss&scoped=true"
import style1 from "./potentialSupplierManageDetail.vue?vue&type=style&index=1&id=314c0ea2&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314c0ea2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('314c0ea2')) {
      api.createRecord('314c0ea2', component.options)
    } else {
      api.reload('314c0ea2', component.options)
    }
    module.hot.accept("./potentialSupplierManageDetail.vue?vue&type=template&id=314c0ea2&scoped=true", function () {
      api.rerender('314c0ea2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/supplierManage/potentialSupplierManageDetail.vue"
export default component.exports